import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Menu, X, Star, ArrowRight } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/73brYUsAAwR6tiFxFDLzsP/Logo.png';
const navItems = [{
  label: 'Ducted Systems',
  href: '/ducted-air-conditioning/'
}, {
  label: 'Split Systems',
  href: '/split-systems-perth/'
}, {
  label: 'Reverse Cycle',
  href: '/reverse-cycle-air-conditioning-perth/'
}, {
  label: 'Smart Zone',
  href: '/smart-zone/'
}, {
  label: 'Pricing',
  href: '#pricing'
}];
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isOpenNow, setIsOpenNow] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const checkOpen = () => {
      const now = new Date();
      const day = now.getDay();
      const hours = now.getHours();
      if (day >= 1 && day <= 4 && hours >= 9 && hours < 16) setIsOpenNow(true);else if (day === 5 && hours >= 9 && hours < 14) setIsOpenNow(true);else setIsOpenNow(false);
    };
    checkOpen();
    const interval = setInterval(checkOpen, 60000);
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearInterval(interval);
    };
  }, []);
  return <div className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white'}`} data-id="element-230">
      {/* Utility bar */}
      <div className={`bg-brand-soft text-brand transition-all duration-300 ${scrolled ? 'h-9' : 'h-10'} overflow-hidden`} data-id="element-231">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between text-xs gap-4" data-id="element-232">
          {/* Left: hours + status */}
          <div className="flex items-center gap-2 font-medium min-w-0" data-id="element-233">
            <span className="live-dot flex-shrink-0" style={{
            background: isOpenNow ? '#16A34A' : '#A8A29E'
          }} aria-hidden="true" data-id="element-234" />
            <span className="hidden md:inline truncate" data-id="element-235">
              {isOpenNow ? <>
                  <span className="font-bold" data-id="element-236">OPEN NOW</span>
                  <span className="mx-2 text-brand/40" data-id="element-237">·</span>
                  <span data-id="element-238">Mon-Thu 9-4, Fri 9-2</span>
                  <span className="mx-2 text-brand/40" data-id="element-239">·</span>
                  <span data-id="element-240">Mike answers personally</span>
                </> : <>
                  <span className="font-bold" data-id="element-241">Next callback:</span>
                  <span className="ml-2" data-id="element-242">Monday 9am</span>
                </>}
            </span>
            <span className="md:hidden font-bold truncate" data-id="element-243">
              {isOpenNow ? 'OPEN NOW · Mon-Thu 9-4' : 'Callback Mon 9am'}
            </span>
          </div>

          {/* Centre: phone (moved out of cluster) */}
          <a href="tel:+61864043888" className="hidden lg:flex items-center gap-1.5 font-bold hover:text-brand-700 transition-colors" aria-label="Call Langler Air" data-id="element-244">
            <Phone size={12} strokeWidth={2.5} data-id="element-245" />
            <span className="tabular-nums" data-id="element-246">08 6404 3888</span>
          </a>

          {/* Right: reviews */}
          <a href="https://www.google.com/search?q=langler+air+perth+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 font-semibold hover:text-brand-700 transition-colors flex-shrink-0" data-id="element-247">
            <div className="flex" data-id="element-248">
              {[0, 1, 2, 3, 4].map(i => <Star key={i} size={11} className="fill-amber-400 text-amber-400" data-id="element-249" />)}
            </div>
            <span className="tabular-nums hidden sm:inline" data-id="element-250">
              5.0 from 75 Google reviews
            </span>
            <span className="tabular-nums sm:hidden" data-id="element-251">5.0 (75)</span>
          </a>
        </div>
      </div>

      {/* Main header */}
      <header className="bg-white" data-id="element-252">
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-8 transition-all duration-300 ${scrolled ? 'h-16' : 'h-20'}`} data-id="element-253">
          <a href="/" aria-label="Langler Air home" className="flex items-center flex-shrink-0" data-id="element-254">
            <img src={LOGO_URL} alt="Langler Air" className={`w-auto transition-all duration-300 ${scrolled ? 'h-9' : 'h-11'}`} data-id="element-255" />
          </a>

          <nav className="hidden lg:flex items-center gap-x-8" aria-label="Main navigation" data-id="element-256">
            {navItems.map(item => <a key={item.label} href={item.href} className="text-sm font-semibold uppercase tracking-wider text-ink-900 hover:text-brand transition-colors whitespace-nowrap" data-id="element-257">
                {item.label}
              </a>)}
          </nav>

          <div className="flex items-center gap-3" data-id="element-258">
            <a href="tel:+61864043888" className="lg:hidden flex items-center gap-1.5 text-brand font-bold text-sm" aria-label="Call Langler Air" data-id="element-259">
              <Phone size={14} strokeWidth={2.5} data-id="element-260" />
              <span className="tabular-nums hidden sm:inline" data-id="element-261">
                08 6404 3888
              </span>
            </a>
            <a href="#quote-form" className="hidden sm:inline-flex items-center gap-1.5 h-12 px-5 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 text-sm font-bold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-md hover:shadow-lg whitespace-nowrap" data-id="element-262">
              Get Free Quote
              <ArrowRight size={15} strokeWidth={2.5} data-id="element-263" />
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 -mr-2 text-ink-900" aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-264">
              {isOpen ? <X size={26} data-id="element-265" /> : <Menu size={26} data-id="element-266" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-267">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} className="lg:hidden bg-white border-t border-stone-200 overflow-hidden" data-id="element-268">
              <nav className="flex flex-col px-4 py-3" aria-label="Mobile navigation" data-id="element-269">
                {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setIsOpen(false)} className="py-3 text-base font-semibold text-ink-900 border-b border-stone-200 last:border-0 hover:text-brand" data-id="element-270">
                    {item.label}
                  </a>)}
                <div className="grid grid-cols-2 gap-2 mt-4 mb-2" data-id="element-271">
                  <a href="tel:+61864043888" className="flex items-center justify-center gap-2 h-12 rounded-xl border-2 border-brand text-brand text-sm font-bold" data-id="element-272">
                    <Phone size={14} data-id="element-273" /> Call us
                  </a>
                  <a href="#quote-form" onClick={() => setIsOpen(false)} className="flex items-center justify-center h-12 rounded-xl bg-accent text-ink-900 text-sm font-bold" data-id="element-274">
                    Free Quote
                  </a>
                </div>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </header>
    </div>;
}